import * as StandardEventsLibrary from '@shopify/events';
import { isDesignMode } from '@theme/standard-events-utils';

const createViewEventElement = StandardEventsLibrary.createViewEventElement;

if (!isDesignMode() && typeof createViewEventElement === 'function') {
  define('product-component', { defaultTrigger: 'intersect' });
  define('collection-component');
  define('cart-items-component', { defaultTrigger: 'manual' });
}

function define(tagName, options) {
  try {
    if (customElements.get(tagName)) return;

    customElements.define(
      tagName,
      options ? createViewEventElement(HTMLElement, options) : createViewEventElement(HTMLElement)
    );
  } catch (error) {
  }
}
